import { channelNames } from '../../../../../../webSocket/channelNames';
import { ParsedNotification } from '../../../types';

export const isJobPostMatchMessage = (notification: Partial<ParsedNotification>): boolean =>
    notification.eventType === channelNames.JOB_POST_MATCHED;

export const hasRequiredFields = (notification: Partial<ParsedNotification>): boolean =>
    Boolean(notification.jobPostId && notification.title);
